import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";

const ENDPOINT = "/license/edit_installations_enabled_modules";

export class EditInstallationsEnabledModulesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: InstallationsEnabledModules[] = null;

    constructor(payload: InstallationsEnabledModules[]) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand(this.payload, null, null);
        return new ServiceResponseData(res);
    }
}

export interface InstallationsEnabledModules {
    name: string;
    enabledModules: number;
}
